import { cn } from "@/lib/utils";
import { prog } from "@/components/demo/DemoKit";

const STOPS = [[0, [38, 22, 64]], [0.45, [130, 36, 227]], [0.72, [196, 84, 170]], [0.88, [232, 150, 90]], [1, [243, 198, 73]]];
export const heat = (h) => {
  const t = Math.max(0, Math.min(1, h / 100));
  const i = STOPS.findIndex(([s]) => s >= t);
  const [s0, a] = STOPS[Math.max(0, i - 1)]; const [s1, b] = STOPS[Math.max(0, i)];
  const k = s1 === s0 ? 0 : (t - s0) / (s1 - s0);
  return `rgb(${a.map((v, j) => Math.round(v + (b[j] - v) * k)).join(",")})`;
};

export const COMPANIES = [["Northwind Pay", 92, 14], ["Ledgerline", 87, 9], ["Brightvault", 81, 8], ["Corva Health", 74, 5], ["Finch AI", 68, 4], ["Quantia", 63, 3], ["Lumen Bank", 58, 4], ["Orbit HR", 52, 2], ["Paystream", 47, 3], ["Helix Labs", 41, 2], ["Nova Freight", 36, 1], ["Cobalt Edu", 31, 2], ["Arcadia", 27, 1], ["Meridian", 22, 1]];

const Tile = ({ n, h, r, lt, a, big, wide }) => {
  const on = prog(lt, a, a + 0.6); const live = h * on; const c = heat(live); const hot = h >= 80;
  return (
    <div className={cn("relative flex flex-col justify-between overflow-hidden rounded-lg p-2", big ? "col-span-2 row-span-2" : wide ? "col-span-2" : "")}
      style={{ opacity: 0.15 + on * 0.85, background: `linear-gradient(140deg, ${c}, ${heat(live * 0.7)})`, boxShadow: hot && on > 0.9 ? `0 0 ${18 + 8 * Math.sin(lt * 3 + h)}px ${heat(h)}99, inset 0 0 0 1px rgba(255,240,200,0.35)` : "inset 0 0 0 1px rgba(255,255,255,0.06)" }}>
      {hot && <span className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/25 to-transparent" style={{ opacity: 0.4 + 0.3 * Math.sin(lt * 2.4 + h) }} />}
      <span className={cn("relative line-clamp-2 font-semibold leading-tight text-white drop-shadow", big ? "text-[14px]" : "text-[10px]")}>{n}</span>
      <span className="relative flex items-end justify-between text-white/80"><span className={big ? "text-[11px]" : "text-[9px]"}>{r} roles</span><span className={cn("font-display font-semibold text-white", big ? "text-[30px] leading-none" : "text-[14px]")}>{Math.round(live)}</span></span>
    </div>
  );
};

export const HeatLegend = ({ className }) => (
  <span className={cn("flex items-center gap-1.5 text-[9px] text-zinc-500", className)}>Cool<span className="h-1.5 w-20 rounded-full" style={{ background: `linear-gradient(90deg, ${[10, 40, 65, 82, 100].map(heat).join(",")})` }} />Hot</span>
);

// App-style hiring heat map: tiles sized by open roles, glowing cool purple to hot gold.
export const HeatTiles = ({ lt, at = 1.5, cols = 4, row = 52, items = COMPANIES.slice(0, 13) }) => (
  <div className="grid grid-flow-dense gap-1.5" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`, gridAutoRows: row }}>
    {items.map(([n, h, r], i) => <Tile key={n} n={n} h={h} r={r} lt={lt} a={at + i * 0.18} big={r >= 14} wide={r >= 8 && r < 14} />)}
  </div>
);

export const HeatStrip = ({ lt, at }) => (
  <div className="flex h-full gap-1.5">{COMPANIES.slice(0, 12).map(([n, h, r], i) => <div key={n} className="flex-1"><Tile n={n} h={h} r={r} lt={lt} a={at + i * 0.12} /></div>)}</div>
);
